export const environment = {
    baseURL: 'https://pagamentos.qualitymanager.com.br', // Production
};